import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OfferDurationLookupComponent } from './offer-duration-offer-lookup.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule } from '@angular/forms';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgSelectModule
  ],
  declarations: [OfferDurationLookupComponent],
  exports: [OfferDurationLookupComponent],
  providers: []
})
export class OfferDurationLookupModule { }
